<template>
<div class="container">
    <div class="row">
        <Button
            v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice"
            class="mb-3"
            @click="handleBackStep"
            size="small"
            type="outline"
            color="grey"
        >
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister @saveChange="validateForm">
            <div class="col-12 d-flex justify-content-between mt-4 mb-3">
                <h4 class="c-ndarkfour bold">
                    Dados gerais
                </h4>
                <h6 class="c-sredfour regular">*Campos obrigatórios</h6>
            </div>
            <!-- <InfoCnpj :info="$store.state.register.company" /> -->
            <div class="col-12 mt-4">
                <el-form
                    :model="company"
                    ref="company"
                    :rules="$store.state.user.userAdm || blockInputs ? rulesAdm : rules"
                    :class="blockInputs"
                >

                    <div class="row mt-2">
                        <div class="col-6">
                            <el-form-item prop="name">
                                <label>Razão social<span class="c-sredfour regular">*</span></label>
                                <InputText
                                    v-model.lazy="company.name"
                                    label=""
                                    placeholder="Razão social"
                                    :readonly="$store.state.register.company.name ? true : false"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="cnpj">
                                <label>CNPJ<span class="c-sredfour regular">*</span></label>
                                <InputText
                                    v-model.lazy="company.cnpj.cnpj"
                                    label="" placeholder="00.000.000/0000-00"
                                    v-mask="'##.###.###/####-##'"
                                    :readonly="$store.state.register.company.cnpj.cnpj ? true : false"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6 mt-2">
                            <el-form-item prop="tradingName">
                                <label>Nome fantasia<span class="c-sredfour regular">*</span></label>
                                <InputText v-model="company.tradingName" label="" placeholder="Nome fantasia" />
                            </el-form-item>
                        </div>
                        <div class="col-6 mt-2">
                            <el-form-item prop="cnae">
                                <!-- <InputText v-model.lazy="company.cnae" label="Atividade principal" placeholder="Atividade principal" :readonly="$store.state.register.company.cnae"/> -->
                                <label>Atividade principal<span class="c-sredfour regular">*</span></label>
                                <el-select
                                    v-model="company.cnae"
                                    placeholder="Atividade principal"
                                    filterable
                                    no-match-text="Atividade pricinpal não encotrada"
                                    :disabled="$store.state.register.company.cnae ? true : false"
                                >
                                    <el-option v-for="cnae in cnaeListItems" :key="cnae.cod" :label="`${cnae.cod} - ${cnae.desc}`" :value="`${cnae.cod} - ${cnae.desc}`">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-6 mt-2">
                            <el-form-item prop="openingDate">
                                <label>Data de abertura</label>
                                <!-- <InputText v-model="company.openingDate" label="Data de abertura" placeholder="Data de abertura" v-mask="'##/##/####'" :readonly="$store.state.register.company.openingDate"/> -->
                                <el-date-picker
                                    :clearable="false"
                                    v-model="company.openingDate"
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    v-mask="'##/##/####'"
                                    placement="top"
                                    :readonly="$store.state.register.company.openingDate ? true : false"
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6 mt-2">
                            <el-form-item prop="lastSocialAgreementChange">
                                <!-- <InputText v-model="company.lastSocialAgreementChange" label="Data da última alteração do contrato social" placeholder="DD/MM/YYYY" v-mask="'##/##/####'" /> -->
                                <label>Data da última alteração do contrato social</label>
                                <el-date-picker
                                    :clearable="false"
                                    v-model="company.lastSocialAgreementChange"
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    v-mask="'##/##/####'"
                                    placement="top"
                                    
                                />
                            </el-form-item>
                        </div>
                        <div class="col-6 mt-2">
                            <el-form-item prop="stateRegister">
                                <InputText
                                    v-model="company.stateRegister"
                                    label="Inscrição estadual da sede"
                                    placeholder="123456789"
                                    
                                />
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="CountyRegister">
                                <InputText
                                    v-model="company.CountyRegister"
                                    label="Inscrição municipal da sede"
                                    placeholder="123456789"
                                    
                                />
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="equityCapital">
                                <!-- <InputText v-model="company.equityCapital" label="Capital social" placeholder="R$ 1.000.000,00" v-money="money"/> -->
                                <label>
                                    Capital social<span class="c-sredfour regular">*</span>
                                </label>
                                <el-input
                                    :class="getPrimaryColor"
                                    v-model="company.equityCapital"
                                    placeholder="R$ 1.000.000,00"
                                    v-money="money"
                                    
                                />
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="website">
                                <InputText v-model="company.website" label="Site" placeholder="www.site.com.br"  />
                            </el-form-item>
                        </div>

                    </div>

                    <!-- <div class="row mt-5">
                        <div class="col-12  mb-4" v-if="$store.state.user.userAdm">
                            <p class="c-ndarkfour medium">
                                Contato
                            </p>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="email" v-if="$store.state.user.userAdm">
                                <InputText type="email" v-model="company.email" label="E-mail da empresa" placeholder="email@gmail.com" />
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="phoneNumber" v-if="$store.state.user.userAdm">
                                <InputText v-model="company.phoneNumber" label="Telefone comercial" placeholder="(11) 3456-5555" v-mask="'(##) ####-####'" />
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="website">
                                <InputText v-model="company.website" label="Site" placeholder="www.site.com.br" />
                            </el-form-item>
                        </div>
                    </div> -->

                    <!-- <div class="row mt-5"> 
                        <div class="col-12 mb-4">
                            <p class="c-ndarkfour medium">
                                Registro (NIRE)
                            </p>
                        </div>
                        <div class="col-4">
                            <el-form-item prop="nireNumber">
                                <InputText v-model="company.nireNumber" label="Número de registro" placeholder="99 9 9999999-9" v-mask="'## # #######-#'"/>
                            </el-form-item>
                        </div>

                        <div class="col-4">
                            <el-form-item prop="nireEmissionDate">
                                //LINHA PREVIAMENTE COMENTADA <InputText v-model="company.nireEmissionDate" label="Data" placeholder="DD/MM/YYYY" v-mask="'##/##/####'" />  
                                <label>Data</label>
                                <el-date-picker :clearable="false" v-model="company.nireEmissionDate" type="date" placeholder="DD/MM/YYYY" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-mask="'##/##/####'" placement="top" />
                            </el-form-item>
                        </div>

                        <div class="col-4">
                            <el-form-item prop="nireIssuer">
                                <InputText v-model="company.nireIssuer" label="Órgão" placeholder="JUCESP (São Paulo)" />
                            </el-form-item>
                        </div>
                    </div> --> 

                    <div class="row mt-4">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">Conta corrente empresarial</p>
                        </div>
                        <div class="col-4">
                            <el-form-item prop="bankInfo.bank">
                                <label>Banco<span class="c-sredfour regular">*</span></label>
                                <el-select v-model="company.bankInfo.bank" filterable placeholder="Banco Bradesco" :disabled="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">
                                    <el-option
                                        v-for="bank in brazilianBankList"
                                        :key="bank.COMPE"
                                        :label="`${bank.COMPE} - ${bank.LongName}`"
                                        :value="bank.COMPE"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item prop="bankInfo.agency">
                                <label>Agência<span class="c-sredfour regular">*</span></label>
                                <el-input :class="getPrimaryColor" v-model="company.bankInfo.agency" placeholder="Agência" :readonly="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice ? true : false"/>
                            </el-form-item>
                        </div>
                        <div class="col-4">
                            <el-form-item prop="bankInfo.account">
                                <label>Conta<span class="c-sredfour regular">*</span></label>
                                <el-input :class="getPrimaryColor" v-model="company.bankInfo.account" placeholder="Conta" :readonly="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice ? true : false"/>
                            </el-form-item>
                        </div>
                        <div class="col-8 mt-3"> 
                            <label>Chave PIX</label> 
                            <el-input v-model="company.bankInfo.pix" placeholder="CPF/CNPJ, celular, e-mail ou chave aleatória " :readonly="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice ? true : false"/> 
                        </div> 
                    </div>

                    <div class="row mt-5">
                        <div class="col-12 mb-4">
                            <p class="c-ndarkfour medium">
                                Informações adicionais
                            </p>
                        </div>

                        <div class="col-4 mb-3">
                            <el-form-item prop="employeesNumber">
                                <Select
                                    
                                    v-model="company.employeesNumber"
                                    label="Quantidade de funcionários"
                                    placeholder="100-200"
                                    :items="[{label: '1-10', value: '1-10'},{label: '10-50', value: '10-50'},{label: '50-100', value: '50-100'},{label: '100-200', value: '100-200'}, {label: '+200', value: '+200'}]"
                                />
                            </el-form-item>
                        </div>

                        <div class="col-5 mb-4">
                            <el-form-item prop="ecnpj">
                                <!-- <InputRadio v-model="company.ecnpj" label="Esta empresa possui E-CNPJ?" :items="['Não', 'Sim']" /> -->
                                <label>
                                    Esta empresa possui e-CNPJ?<span class="c-sredfour regular">*</span>
                                    <!--
                                        <el-tooltip placement="bottom" class="ml-1">
                                            <template slot="content">
                                                Certificado digital que identifica uma empresa no meio eletrônico, <br>
                                                permitindo assinatura de documentos com validade jurídica, <br>
                                                emissão de notas fiscais, comunicação com a Receita Federal, <br>
                                                entre outros serviços.
                                            </template>
                                            <Question color="#A1A8B8" />
                                        </el-tooltip>
                                    -->
                                </label>
                                <el-radio @change="validateECnpjField" :class="getPrimaryColor" v-model="company.ecnpj" :label="true">Sim</el-radio>
                                <el-radio @change="validateECnpjField" :class="getPrimaryColor" v-model="company.ecnpj" :label="false">Não</el-radio>
                                <!--
                                    <el-link @click="serasaExperianDialogVisible = true" :class="`c-${getPrimaryColor}four pt-0 pr-0 ml-n3`" v-if="!$store.state.user.userAdm && !USER_TYPE_MIXIN.isBackOffice">
                                        Quero contratar<i class="el-icon-arrow-right el-icon--right ml-1"></i>
                                    </el-link>
                                -->
                            </el-form-item>
                        </div>

                        <div class="col-12 mb-4" v-if="!$store.state.user.accessLevel">
                            <el-form-item prop="intentUseCredit">
                                <label>Sua empresa pretende antecipar recebíveis ou utilizar outras linhas de crédito disponíveis na plataforma?</label>
                                <el-radio :class="getPrimaryColor" v-model="company.cnpj.intentUseCredit" :label="true" :checked="company.cnpj.intentUseCredit">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="company.cnpj.intentUseCredit" :label="false" :checked="!company.cnpj.intentUseCredit">Não</el-radio>
                            </el-form-item>
                        </div>

<!--                         <div class="col-6" v-if="$store.state.user.userAdm">
                            <el-form-item prop="registerComplete">
                                <label class="c-ndarkfour regular">Possui cadastro completo?</label>
                                <el-radio :class="getPrimaryColor" v-model="company.registerComplete" label="1">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="company.registerComplete" label="0">Não</el-radio>
                            </el-form-item>
                        </div> -->
                    </div>

                    <!-- <div class="row mt-3" v-if="$store.state.user.userAdm">

                        <div class="col-6">
                            <el-form-item prop="registrationForm">
                                <label>Ficha cadastral</label>
                                <el-checkbox v-model="company.registrationFormPj" label="Cadastro Pessoa Jurídica"></el-checkbox>
                                <el-checkbox v-model="company.billingStatement" label="Declaração de Faturamento"></el-checkbox>
                                <el-checkbox v-model="company.statementFinancialInstitutions" label="Declaração de Instituições Financeiras"></el-checkbox>
                            </el-form-item>
                        </div>

                        <div class="col-6 mr-0 pr-0">
                            <el-form-item prop="documents">
                                <label>Documentos</label>
                                <el-checkbox v-model="company.socialContract" label="Contrato social e/ou última alteração contratual"></el-checkbox>
                                <el-checkbox v-model="company.dre" label="Balanço e DRE do último exercício"></el-checkbox>
                                <el-checkbox v-model="company.cnpjCard" label="Cartão CNPJ"></el-checkbox>
                            </el-form-item>
                        </div>

                    </div> -->
                </el-form>

                <div class="row mb-5 mt-2">
                    <RegisterNavigationButtons v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" @backStep="backStep" @nextStep="nextStep" @saveChange="validateForm"/>
                    <div v-else class="col-12 d-flex align-items-center">
                        <!-- <router-link to="" @click.native="handleBackStep"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
                            Voltar
                        </router-link> -->
                        <Button @click="handleBackStep" class="mr-4 px-3" type="outline" :color="getPrimaryColor" v-if="!$store.state.user.userAdm">
                            <ArrowDropdown :rotate="90" :color="getPrimaryColorHex.four"/>
                            Voltar
                        </Button>
                        <Button v-if="!blockInputs" @click="validateForm" :color="getPrimaryColor"> Salvar e continuar </Button>
                        <Button v-else @click="nextStep" :color="getPrimaryColor"> Continuar </Button>
                    </div>
                </div>

            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @cancelRegister="backStep"  @saveChange="validateForm"/>
    <!--
        <SerasaExperianRegister :dialogVisible="serasaExperianDialogVisible" @closeModal="serasaExperianDialogVisible = $event" @sendEmail="sendEmail"/>
        <SerasaExperianEmail :dialogVisible="serasaExperianEmailVisible" @closeModal="serasaExperianEmailVisible = $event"/>
    -->
</div>
</template>

<script>
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import RegisterNavigationButtons from '@/components/register/RegisterNavigationButtons'
import CancelRegister from '@/components/modals/CancelRegister'
//import SerasaExperianRegister from '@/components/modals/SerasaExperianRegister' 
//import SerasaExperianEmail from '@/components/modals/SerasaExperianEmail' 
import ArrowDropdown from '@/components/icons/ArrowDropdown'
//import Question from '@/components/icons/Question' 
import BoxRegister from '@/components/box/BoxRegister'
//import InfoCnpj from '@/components/infos/InfoCnpj'
import updateCompany from '@/api/updateCompany'
import getBankAccount from '@/api/getBankAccount'
//import sendSerasaExperianEmail from '@/api/sendSerasaExperianEmail'
//import getUserData from '@/api/getUserData'
import removeMask from '@/utils/removeMask'
import cnaeList from '@/utils/cnaeList'
import banksList from '@/utils/banksList'
import RegisterHeader from '@/components/register/RegisterHeader'
import statusCodesBlockInput from '@/utils/statusCodesBlockInput'
import updateRegisterStep from '../../../api/updateRegisterStep'
import Vue from 'vue'
import {
    VMoney
} from 'v-money'
import insertBankAccount from '@/api/insertBankAccount'
import updateBankAccount from '@/api/updateBankAccount'

export default {
    components: {
        //CompanyTypeStatus,
        CancelRegister,
        //SerasaExperianRegister, 
        //SerasaExperianEmail, 
        BoxRegister,
        //InfoCnpj,
        ArrowDropdown,
        //Question, 
        RegisterHeader,
        RegisterNavigationButtons
    },
    data() {
        const validateAmount = (_rule, value, message) => {
            if (parseInt(value.toString().replace(/\D/g, '')) <= 0) message("Por favor, insira o capital social")
            //if (parseInt(value.toString().replace(/\D/g, '')) <= 0) message("Por favor, insira o valor a ser financiado")
            else message()
        }
        return {
            dialogVisible: false,
            brazilianBankList: banksList,
            //serasaExperianDialogVisible: false, 
            //serasaExperianEmailVisible: false, 
            cnaeListItems: cnaeList,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
            },
            bankInfoId: null,
            company: {
                name: '',
                tradingName: '',
                cnae: '',
                openingDate: '',
                cnpj: {
                    cnpj: '',
                    intentUseCredit: true
                },
                stateRegister: '',
                CountyRegister: '',
                lastSocialAgreementChange: '',
                equityCapital: '',
                email: '',
                phoneNumber: '',
                website: '',
                nireNumber: '',
                nireEmissionDate: '',
                nireIssuer: '',
                employeesNumber: '',
                ecnpj: true,
                registrationFormPj: false,
                billingStatement: false,
                statementFinancialInstitutions: false,
                socialContract: false,
                cnpjCard: false,
                dre: false,
                registrationFormPfAndPolitical: false,
                bankInfo: {
                    bank: '',
                    agency: '',
                    account: '',
                    pix: '',
                    mainAccount: 1,
                },
            },
            rulesAdm: {},
            rules: {
                name:[{
                    required: true,
                    message: 'Por favor, insira a sue nome',
                    trigger: 'change'
                }],
                tradingName:[
                    {
                        required: true,
                        message: 'Por favor, insira o nome fantasia',
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        message: 'Por favor, insira o nome fantasia',
                        trigger: 'change'
                    }
                ],
                cnae:[{
                    required: true,
                    message: 'Por favor, selecione uma atividade principal',
                    trigger: 'change'
                }],
                /* openingDate:[
                    {
                        required: true,
                        message: 'Por favor, insira a data de abertura',
                        trigger: 'change'
                    },
                    {
                        required: true,
                        message: 'Por favor, insira a data de abertura',
                        trigger: 'change'
                    }
                ], */
                cnpj:[{
                    required: true,
                    message: 'Por favor, insira o cnpj',
                    trigger: 'change'
                }],
                /* stateRegister:[
                    {
                        required: true,
                        message: 'Por favor, insira a inscrição estadual',
                        trigger: 'blur'
                    },
                    {
                        min: 1,
                        message: 'Por favor, insira a inscrição estadual',
                        trigger: 'change'
                    },
                ], */
                /* CountyRegister:[
                    {
                        required: true,
                        message: 'Por favor, insira a inscrição municipal',
                        trigger: 'blur'
                    },
                    {
                        min: 1,
                        message: 'Por favor, insira a inscrição estadual',
                        trigger: 'change'
                    },
                ], */
                /* lastSocialAgreementChange:[
                    {
                        required: true,
                        message: 'Por favor, insira uma data',
                        trigger: 'blur'
                    },
                    {
                        min: 9,
                        message: 'Por favor, insira uma data válida',
                        trigger: 'change'
                    }
                ], */
                equityCapital:[
                    {
                        required: true,
                        validator: validateAmount,
                        trigger: 'blur'
                    },

                ],
                /* website:[{
                    required: true,
                    message: 'Por favor, insira o endereço do site',
                    trigger: 'change'
                }], */
                /* nireNumber:[
                    {
                        required: true,
                        message: 'Por favor, insira o número de registro',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        min: 12,
                        message: 'Por favor, insira o número de registro',
                        trigger: 'change'
                    }
                ], */
                /* nireEmissionDate:[
                    {
                        required: true,
                        message: 'Por favor, insira a data',
                        trigger: 'blur'
                    },
                    {
                        min: 9,
                        message: 'Por favor, insira uma data válida',
                        trigger: 'change'
                    }
                ], */
                /* nireIssuer:[
                    {
                        required: true,
                        message: 'Por favor, insira o órgão',
                        trigger: 'change'
                    }
                ], */
                /* employeesNumber:[
                    {
                        required: true,
                        message: 'Por favor, seleciona a quantidade',
                        trigger: 'change'
                    }
                ], */
                ecnpj:[{
                    required: true,
                    message: 'Por favor, selecione uma opção',
                    trigger: 'change'
                }],
                'bankInfo.bank': [{
                    required: true,
                    message: 'Por favor, selecione um banco',
                    trigger: 'change'
                }],
                'bankInfo.agency': [{
                    required: true,
                    message: 'Por favor, insira o número da agência',
                    trigger: 'blur'
                }],
                'bankInfo.account': [{
                    required: true,
                    message: 'Por favor, insira o número da conta corrente',
                    trigger: 'blur'
                }]
            },
            formValid: false,
        }
    },
    directives: {
        money: VMoney
    },
    watch: {
        company: {
            deep: true,
            handler() {
                if (!this.$store.state.register.formIsChanged) {
                    this.$store.commit('register/setFormIsChanged', true)
                }                
            }
        }
    },
    computed: {
        // bank() {
        //     const bankEntry = banksList.find(bank => bank.COMPE == this.bankInfo.bank)
        //     if (bankEntry) {
        //         return `${bankEntry.COMPE} - ${bankEntry.LongName}`
        //     } else {
        //         return ''
        //     }
        // },
        blockInputs() {
            const { isBackOffice, isAdm } = this.USER_TYPE_MIXIN
            const registerComplete = this.$store.state.register.company.cnpj.registerComplete
            return ((!isAdm && !isBackOffice) && statusCodesBlockInput.includes(registerComplete)) ? 'input-block' : ''
            //return (!this.$store.state.user.userAdm && statusCodesBlockInput.includes(this.$store.state.register.company.cnpj.registerComplete)) || this.USER_TYPE_MIXIN.isBackOffice ? 'input-block' : ''
        },
    },
    methods: {
        validateForm() {
            console.log(this.$refs['company']);
            
            this.$refs['company'].validate((valid) => {
                
                if (valid) {
                    this.saveChanges()
                } else {
                    this.$notify({
                        title: 'Por favor, preencha todos os campos!',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            });
        },
        validateECnpjField() {
            this.$refs['company'].validateField('ecnpj')
        },
        nextStep() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                if (this.$route.path.includes('update')) {
                    this.$router.push(`/provider/update/${this.$route.params.idCNPJ}/1`)
                } else {
                    this.$router.push(`/provider/register/${this.$route.params.idCNPJ}/1`)
                }
            } else {
                this.$router.push(`/company/register/${this.$route.params.idCNPJ}/1`)
            }
        },
        async saveChanges() {
            const unmaskedCompany = {
                ...this.company,
                equityCapital: removeMask(this.company.equityCapital)
            }
            const result = await updateCompany(this.$route.params.idCNPJ, unmaskedCompany)
            if (!this.bankInfoId) {
                await insertBankAccount({ cnpjId: this.$store.state.user.cnpjId, ...this.company.bankInfo })
            } else {
                await updateBankAccount({id: this.bankInfoId, ...this.company.bankInfo })
            }
            if (result.ok) {
                this.$notify({
                    title: 'Dados salvos com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
                await updateRegisterStep(this.$route.params.idCNPJ, { step: 1})
                this.$store.commit('register/setCompany', this.company)
                this.$store.commit('register/setFormIsChanged', false)
                if (!this.$store.state.user.userAdm) this.nextStep()
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }            
        },
        backStep() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                const regex = /provider|buyer|sponsor/g
                this.$router.push(`/company/${this.$route.path.match(regex)[0]||''}`)
            } else {
                this.$router.push(`/company/register/${this.$route.params.idCNPJ}/message?status=${this.$store.state.user.registerComplete}`)
            }
        },
        handleBackStep() {
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        async getBankAccountInfo() {
            const result = await getBankAccount(this.$route.params.idCNPJ)
            if (result.ok && result.payload.length) {
                const bankAccount = result.payload.find(account => account.mainAccount == 1)
                if (bankAccount) {
                    const {
                        bank,
                        account,
                        agency,
                        pix,
                        id,
                    } = bankAccount
                    this.company.bankInfo = {
                        bank,
                        account,
                        agency,
                        pix,
                    }
                    this.bankInfoId = id
                }
            }
        },
        //async sendEmail() {
        //    this.serasaExperianDialogVisible = false
        //
        //    if (!this.$store.state.user.infos.name || !this.$store.state.user.infos.email || !this.$store.state.user.infos.phoneNumber) {
        //        await getUserData(this.$store.state.user.token)
        //    }
        //
        //    const response = await sendSerasaExperianEmail({
        //        companyName: this.$store.state.register.company.name,
        //        companyCnpj: this.$store.state.register.company.cnpj.cnpj,
        //        responsibleName: this.$store.state.user.infos.name,
        //        responsibleEmail: this.$store.state.user.infos.email,
        //        responsiblePhone: this.$store.state.user.infos.phoneNumber
        //    })
        //
        //    if (response.ok) {
        //        this.serasaExperianEmailVisible = true
        //    } else {
        //        this.$notify({
        //            title: 'Ops, algo deu errado! O e-mail não foi enviado.',
        //            message: '',
        //            type: 'error',
        //            duration: 3000,
        //            offset: 100,
        //            showClose: false,
        //            customClass: 'error'
        //        });
        //    }
        //}
    },
    created() {
        const {
            company
        } = this.$store.state.register
        this.company = {
            name: company.name,
            tradingName: company.tradingName,
            cnae: company.cnae,
            openingDate: company.openingDate,
            cnpj: { ...company.cnpj },
            stateRegister: company.stateRegister,
            CountyRegister: company.CountyRegister,
            lastSocialAgreementChange: company.lastSocialAgreementChange,
            equityCapital: company.equityCapital,
            email: company.email,
            phoneNumber: company.phoneNumber,
            website: company.website,
            nireNumber: company.nireNumber,
            nireEmissionDate: company.nireEmissionDate,
            nireIssuer: company.nireIssuer,
            employeesNumber: company.employeesNumber,
            ecnpj: company.ecnpj,
            registrationFormPj: company.registrationFormPj,
            billingStatement: company.billingStatement,
            statementFinancialInstitutions: company.statementFinancialInstitutions,
            socialContract: company.socialContract,
            cnpjCard: company.cnpjCard,
            dre: company.dre,
            registerComplete: company.cnpj.registerComplete,
            bankInfo: {
                bank: '',
                agency: '',
                account: '',
                pix: '',
                mainAccount: 1,
            },
        }
        this.getBankAccountInfo()
        this.$store.commit('register/setFormIsChanged', false)
    },
    mounted() {
        Vue.nextTick(() => {
            this.$store.commit('register/setFormIsChanged', false)
        })
    }

}
</script>

<style lang="scss" scoped>
</style>
